import { Account } from 'views/account';
import { AccountUsers } from 'views/account/accountUsers';
import { APIKeyList } from 'views/account/apikey/list';
import { APIKeyEditor } from 'views/account/apikey/edit';
import { Emails } from 'views/account/emails';

const Routes = [
  {
    path: '/account/:id',
    view: Account,
    layout: 'firm',
    permission: 'admin',
    title: 'Account Details'
  },
  {
    path: '/account/users',
    view: AccountUsers,
    layout: 'firm',
    permission: 'admin',
    title: 'Users'
  },
  {
    path: '/account/:id/apikeys',
    view: APIKeyList,
    layout: 'firm',
    permission: 'developer', 
    title: 'API Keys'
  },
  {
    path: '/account/:id/apikeys/create',
    view: APIKeyEditor,
    layout: 'firm',
    permission: 'developer', 
    title: 'API Keys'
  },
  {
    path: '/account/:id/apikeys/edit',
    view: APIKeyEditor,
    layout: 'firm',
    permission: 'developer',
    title: 'API Keys'
  },
  {
    path: '/account/:id/emails',
    view: Emails,
    layout: 'firm',
    permission: 'admin',
    title: 'E-mail Info'
  }
]

export default Routes;